import { Quote } from "lucide-react";
import Image from "next/image";

type ReviewProps = {
    reviewer: {
        message: string,
        image: string,
        name: string,
        title: string
    }
}

export default function ReviewCard({reviewer}:ReviewProps) {
    return (
        <div className="flex flex-col items-start justify-start w-[400px] p-2 bg-gray-200 py-5 gap-5 relative">
            <span><Quote width={60} height={60} className="rotate-180 absolute text-secondary/40 top-2 left-6"/></span>
            <div className="flex w-full text-black px-12">
                <h4 className="text-[16px]">{reviewer.message}</h4>
            </div>
            <div className="flex items-start gap-4 pl-6">
                <Image src={reviewer.image} alt="review-person" width={35} height={35} className="mt-2 object-cover object-center rounded-full" />
                <div className="flex flex-col text-black">
                    <h4>{reviewer.name}</h4>
                    <h4 className="text-primary font-semibold">{reviewer.title}</h4>
                </div>
            </div>
        </div>
    );
}